(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDialogBody', drvDialogBody);

    function drvDialogBody() {
        var directive = {
            restrict: 'E',
            scope: {
                closeOnClick: '&?'
            },
            transclude: true,
            replace: true,
            template:
                '<div class="modal-body">' +
                '   <div flex="100" layout="row">' +
                '       <div flex="" id="modal-body">' +
                '           <ng-transclude></ng-transclude>' +
                '       </div>' +
                '       <div flex="nogrow" ng-if="closeOnClick">' +
                '           <md-button aria-label="Close" ng-click="closeOnClick()" class="md-icon-button" style="padding: 4px;">' +
                '               <drv-icon usage="\'close\'" colour="\'rgb(128,128,128)\'"></drv-icon>' +
                '           </md-button>' +
                '       </div>' +
                '   </div>' +
                '</div>'
        };
        return directive;
    }
})();